
const QuoteText = ({ text } : { text : string }) => {
  return (
    <p className="quote-text">
        {text}
    </p>
  )
}

export default QuoteText